'use client';

import { useState, useEffect } from 'react';
import { TIMING_CONSTANTS } from '@shared/constants';

/**
 * A hook that debounces a value, useful for search inputs, etc.
 * @param value The value to debounce
 * @param delay The delay in milliseconds
 * @returns The debounced value
 */
export function useDebounce<T>(value: T, delay = TIMING_CONSTANTS.SHORT_DELAY): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);
    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);
  return debouncedValue;
} 
